<template>
  <div class="chart-block" style="min-height:348px"  >
    <h3>    <a :href="url" target="_blank"> {{chartName}}</a>
      <el-tooltip class="item" effect="dark"  placement="bottom">
             <div v-html="tip" slot="content"></div> 
        <svg-icon name="faq" size="20" color="#53b1e7"></svg-icon>
      </el-tooltip>
      <span>{{updated}}</span>
   


       <el-radio-group v-model="carType" size="mini" class="opt" @change="bindTable()" :disabled="loading"  >
                <el-radio-button label="整体"></el-radio-button>
                <el-radio-button label="传统"></el-radio-button>
                <el-radio-button label="新能源"></el-radio-button>
  
            </el-radio-group>
    </h3>
    <div style="padding:15px 10px 10px 10px;" v-loading="loading"> 
      <table class="newcar">
        <tr class="head">
          <th style="width:180px;">厂商</th>
          <th>车型<span> (车款数量)</span></th>
          <th style="width:80px;">工改模</th>
          <th style="width:100px;">上市时间</th>
        </tr>
   
        <tr class="sale-ls-row" v-for="( item,index) in tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)" :key="index" @click="showEquip(item)">
          <td>{{item.factory}} </td>
          <td>{{item.model}} ({{item.count}}) </td>
          <td>{{item.Engineering}}</td>
          <td>{{item.start}}</td>
        </tr>
      </table>

       <el-pagination class="fy"
                     layout="prev, pager, next"
                     @current-change="current_change"
                     :total="total"
                     background
                     :current-page="currentPage"
                    >
                  </el-pagination>
    </div>
  </div>
</template>
<script>
  import {
    mapMutations,
    mapGetters,
    mapActions,
    mapState
  } from "vuex";
  import {
    strToYeayAndMonth,strToFormatDate
  } from '@/plugins/DateTimeFormater.js';
  export default {
    data() {
      return {
        url:"#",
        tip:'NP：新车 <br/>GP：换代<br/>NM：新增<br/>MCE3:大改款<br/>MCE2-1:中改款<br/>MCE2-2:动力调整<br/>MCE1:小改款<br/>MSRP：价格调整',
        total:24,//默认数据总数
        pagesize:8,//每页的数据条数
        currentPage:1,//默认开始页面
        chartName: "新车上市",
        chartId: "new_car_start_market",
        updated: '',
        newCarData: [],
        tableData: [],
        carType: '整体',
        loading: true,
      };
    },
    methods: {
      ...mapActions("home", ["queryChartConfigs", "queryChartUpdate", "getChartList","queryChartBuild","queryNewCarIds"]),
      updateChart() {

        var info = this.getChartByName(this.chartId);
        this.url = info.url;
       if(info.updateOption==2){
        this.newCarData = eval(info.jsonData);
        this.updated = `最新数据时间 ${strToYeayAndMonth(info.lastUpdated)}`;
        this.bindTable();
       }else if(info.updateOption==1)
       {
         var self = this;
          var postData = {'chartName':this.chartId,'noCache':false};
          this.queryChartBuild({params:postData,handle:function(res){
               self.newCarData = res.data;
               self.updated = `最新数据时间 ${strToFormatDate(res.updated)}`;
               self.bindTable();
            }});
       }
      
      },
      bindTable() {
        this.currentPage =1;
        this.loading = false;
        this.tableData = [];
        for (var x of this.newCarData) {
          if (x.energy == this.carType) {
            this.tableData.push(x);
          }
        }
        
      },
      current_change:function(currentPage){
        this.currentPage = currentPage;
      },
      showEquip(item){
       let self = this;
        var postData ={model:item.model,ggm:item.Engineering,date:item.start};
        this.queryNewCarIds({params:postData,cb:function(res){            
             var ids = res.result;
            
         self.$router.push({
          name: 'equipanalysis',
          query: {
            'ids': JSON.stringify(ids)
          }
        });

        }});
        

    
      
      
      }
    },
    mounted() {
      this.getChartList({
        handle: this.updateChart
      });
    },
    computed: {
      ...mapGetters("home", {
        chartList: "chartList",
        getChartByName: "getChartByName"
      }),
    },
  };
</script>
<style scoped>
  .newcar {
    width: 100%;
    font-size: 9pt;
    border-collapse: collapse;
  }
  .newcar tr td {
    text-align: center;
  }
  .newcar tr:nth-child(2n+3) {
    background: #f2f2f2;
  }
  .newcar tr {
    height: 28px;
  }
  .newcar .head {
    background: #6195e8;
    color: #fff
  }
  .newcar .head th span {
    font-size: .7em;
    font-weight: normal;
  }
  .fy{ margin-top:10px;}
</style>